import "./App.css";
import React from "react";
import SlidingTextBar from "./components/SlidingTextBar";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Services from "./components/Services";
import Promos from "./components/Promos";
import Comments from "./components/Comments";
import Form from "./components/Form";
import Bna from "./components/Bna";

function App() {
  return (
    <div className="App">
      <Navbar />

      <Header />

      <SlidingTextBar />

      <Services />

      <Promos />

      <Comments />

      <Form />

      <Bna />

      <div className="footer">
        <p translate="no">© Cute and Care 2025</p>
      </div>
    </div>
  );
}

export default App;
